export const BACK_OFFICE_TEAM = [
  {
    name: "Lucie F.",
    email: "lucie@agentsvp.cz",
    phone: "+420 511 444 092",
    photo: "https://customer-assets.emergentagent.com/job_9879810e-737b-4799-a6fe-996a46a41811/artifacts/utg8min0_lucie.JPG"
  },
  {
    name: "Kateřina M.",
    email: "katerina.miller@agentsvp.cz",
    phone: "+420 511 444 093",
    photo: "https://customer-assets.emergentagent.com/job_9879810e-737b-4799-a6fe-996a46a41811/artifacts/d68qvncj_katka.JPG"
  },
  {
    name: "Pavlína M.",
    email: "pavlina.mikulaskova@agentsvp.cz",
    phone: "+420 511 444 094",
    photo: "https://customer-assets.emergentagent.com/job_9879810e-737b-4799-a6fe-996a46a41811/artifacts/vdci87ua_pavlina.JPG"
  },
  {
    name: "Veronika A.",
    email: "veronika.andrejsi@agentsvp.cz",
    phone: "+420 511 444 095",
    photo: "https://customer-assets.emergentagent.com/job_9879810e-737b-4799-a6fe-996a46a41811/artifacts/mt9k756z_verca.JPG"
  },
  {
    name: "Petra V.",
    email: "petra.vaculikova@agentsvp.cz",
    phone: "+420 511 444 097",
    photo: "https://customer-assets.emergentagent.com/job_9879810e-737b-4799-a6fe-996a46a41811/artifacts/covic4i0_petra.JPG"
  },
  {
    name: "Nikola M.",
    email: "nikola.mirvaldova@agentsvp.cz",
    phone: "+420 511 444 098",
    photo: "https://customer-assets.emergentagent.com/job_9879810e-737b-4799-a6fe-996a46a41811/artifacts/wj4dyo7f_nikola.JPG"
  }
];
